import { AnalyticsSdk, generateUUID, getTimeZone, getSessionID } from '../pdtUtils';
import {
  LOB_RAILS,
  EVENT_NAME_PAGE_RENDERED,
  EVENT_TYPE_PAGE,
  ORGANISATION_MMT,
  BU_GROUND_TRANSPORT,
  RIS_PDT_SCHEMA_ID,
  RIS_PDT_SCHEMA_NAME,
  PAGE_TYPE_FUNNEL,
  FUNNEL_STEP_DETAIL,
  FUNNEL_SOURCE_SEO,
  PAGE_NAME_HOME,
  SEO_PAGE_EVENT,
  XDM_PAGE_NAME
} from '../constants';

export const logPnrLandingPageLoadEvent = async () => {
  try {
    if (typeof window === 'undefined') return;

    if (!AnalyticsSdk) return;
    const isDev = process.env.NODE_ENV !== 'production';
    const sessionId = getSessionID();
    const journeyId = generateUUID();

    const components = { id: 'pnr_landing_page_load' };

    const searchContext = {
      from: {
        locus: {
          locus_id: 'NA',
          locus_type: 'NA',
          country: 'India',
          locus_v2_id: 'NA',
          locus_v2_type: 'NA'
        },
        location: { code: 'NA', name: 'NA', country_code: 'IN', country: 'India' }
      },
      to: {
        locus: {
          locus_id: 'NA',
          locus_type: 'NA',
          country: 'India',
          locus_v2_id: 'NA',
          locus_v2_type: 'NA'
        },
        location: { code: 'NA', name: 'NA', country_code: 'IN', country: 'India' }
      },
      travel_class: 'All',
      advance_purchase: 'NA'
    };

    const payload = {
      page_context: {
        lob: LOB_RAILS,
        page_type: PAGE_TYPE_FUNNEL,
        page_name: XDM_PAGE_NAME.PNR,
        prev_page_name: PAGE_NAME_HOME,
        funnel_step: FUNNEL_STEP_DETAIL,
        lob_category: LOB_RAILS
      },
      event_tracking_context: {
        env: isDev ? 'dev' : 'prod',
        timezone: getTimeZone(),
        session_id: sessionId,
        funnel_source: FUNNEL_SOURCE_SEO,
        bu: BU_GROUND_TRANSPORT,
        organisation: ORGANISATION_MMT,
        journey_id: journeyId,
        template_id: RIS_PDT_SCHEMA_ID,
        topic_name: RIS_PDT_SCHEMA_NAME
      },
      search_context: searchContext,
      event_detail: {
        event_name: EVENT_NAME_PAGE_RENDERED,
        event_type: EVENT_TYPE_PAGE,
        event_id: generateUUID(),
        event_timestamp: Date.now(),
        event_value: SEO_PAGE_EVENT.PNR_SEARCH,
        components
      },
      experiment_details: {
        valid_exp_list: [] as string[],
        variant_keys: '',
        honoured_exp_list: [] as string[]
      }
    };

    const xdmPayload = {
      ...payload,
      event_detail: {
        ...payload.event_detail,
        components: [components]
      }
    };

    const extraOptions = { lob: LOB_RAILS, destinationUrl: window?.location?.href || '' };

    AnalyticsSdk?.pushToPDT?.(payload, extraOptions);
    AnalyticsSdk?.pushToAdobeDataLayer?.(xdmPayload, extraOptions);
  } catch (e) {
    console.error('Analytics: PNR landing page load event failed', e);
  }
};
